<template>
  <div class="col-sm-12">

    <div class="card mb-3">
      <div class="card-header">
        <h4 class="mb-0">Instalación</h4>
      </div>
      <div class="card-body">
        <div class="row g-2 align-items-end">
          <div class="col-md-3">
            <label class="form-label mb-1">Organización</label>
            <select class="form-select" v-model="filtros.organizacionId" @change="onChangeOrganizacion">
              <option value="">Todas</option>
              <option v-for="org in organizaciones" :key="org.id" :value="org.id">{{ org.nombre }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1">Quincena</label>
            <select
              class="form-select"
              v-model="filtros.quincenaId"
              :disabled="!filtros.organizacionId || cargandoQuincenas"
              @change="onChangeQuincena"
            >
              <option value="">{{ cargandoQuincenas ? 'Cargando...' : 'Seleccione' }}</option>
              <option v-for="q in quincenas" :key="q.id" :value="q.id">{{ quincenaLabel(q) }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1">Fecha inicial</label>
            <input v-model="filtros.fechaInicial" class="form-control" type="date" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1">Fecha final</label>
            <input v-model="filtros.fechaFinal" class="form-control" type="date" />
          </div>
          <div class="col-auto">
            <button type="button" class="btn btn-primary" :disabled="buscando" @click="buscar">
              <vue-feather type="search" size="14" class="me-1" />
              {{ buscando ? 'Buscando...' : 'Buscar' }}
            </button>
          </div>
          <div class="col-auto">
            <div class="btn-group" role="group">
              <button type="button" class="btn btn-outline-secondary" :disabled="!rows.length" @click="exportarFormatoOrganizacion">
                Formato de la Organización
              </button>
              <button type="button" class="btn btn-outline-secondary" :disabled="!rows.length" @click="exportarPDF">
                PDF
              </button>
              <button type="button" class="btn btn-outline-secondary" :disabled="!rows.length" @click="exportarXLS">
                XLS
              </button>
              <button type="button" class="btn btn-outline-secondary" :disabled="!rows.length" @click="exportarTXT">
                TXT
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="buscado" class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h6 class="mb-0 fw-bold">
          Resultados
          <span class="badge bg-warning text-dark ms-1" style="font-size:10px;">Datos de ejemplo</span>
        </h6>
        <small class="text-muted">{{ rows.length }} registro(s)</small>
      </div>
      <div class="card-body p-0">
        <div v-if="!rows.length" class="text-center py-4 text-muted small">
          No se encontraron registros.
        </div>
        <div v-else ref="tablaScroll" class="tabla-scroll" :style="{ '--tabla-max-height': tablaMaxHeight + 'px' }">
          <DataTable :rows="rows" :columns="columns" :show-actions="false">
            <template #cell-IMPORTE="{ value }">
              {{ formatCurrency(value) }}
            </template>
            <template #header-_incluir>
              Incluir
              <input type="checkbox" :checked="todosSeleccionados" @change="toggleTodos" />
            </template>
            <template #cell-_incluir="{ item }">
              <input type="checkbox" v-model="item._incluir" />
            </template>
          </DataTable>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/axios';
import { fetchAllItems } from '@/utils/listResponse';
import * as XLSX from 'xlsx';
import html2pdf from 'html2pdf.js';
import DataTable from '@/components/DataTable.vue';
import { getCached, setCached } from '@/utils/catalogCache';
import EJEMPLO_PAGOS from '@/data/ejemploPagosSimm.json';

const MESES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

export default {
  name: 'Instalacion',
  components: { DataTable },

  data() {
    return {
      organizaciones: [],
      quincenas: [],
      cargandoQuincenas: false,
      filtros: {
        organizacionId: '',
        quincenaId: '',
        fechaInicial: '',
        fechaFinal: '',
      },
      buscando: false,
      buscado: false,
      rows: [],
      tablaMaxHeight: 400,
      columns: [
        { text: 'DEPENDENCIA', value: 'DEPENDENCIA' },
        { text: 'QNA', value: 'QNA' },
        { text: 'POLIZA', value: 'POLIZA' },
        { text: 'RFC', value: 'RFC' },
        { text: 'EMPLEADO', value: 'EMPLEADO' },
        { text: 'IMPORTE', value: 'IMPORTE' },
        { text: 'Incluir', value: '_incluir' },
      ],
    };
  },

  computed: {
    todosSeleccionados() {
      return this.rows.length > 0 && this.rows.every(row => row._incluir);
    },
  },

  created() {
    this.cargarOrganizaciones();
  },

  mounted() {
    window.addEventListener('resize', this.actualizarAlturaTabla);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.actualizarAlturaTabla);
  },

  methods: {
    actualizarAlturaTabla() {
      const el = this.$refs.tablaScroll;
      if (!el) return;
      const top = el.getBoundingClientRect().top;
      const disponible = window.innerHeight - top - 24;
      this.tablaMaxHeight = Math.max(disponible, 200);
    },

    async cargarOrganizaciones() {
      const cached = getCached('cat_v2_organizaciones');
      if (cached) {
        this.organizaciones = cached;
        return;
      }
      try {
        const { items } = await fetchAllItems('organizaciones');
        this.organizaciones = items.map(o => ({ id: o.id, nombre: o.nombre }));
        setCached('cat_v2_organizaciones', this.organizaciones);
      } catch (err) {
        console.error('Error al cargar organizaciones:', err);
      }
    },

    onChangeOrganizacion() {
      this.filtros.quincenaId = '';
      this.filtros.fechaInicial = '';
      this.filtros.fechaFinal = '';
      this.quincenas = [];
      if (this.filtros.organizacionId) {
        this.cargarQuincenas(this.filtros.organizacionId);
      }
    },

    async cargarQuincenas(organizacionId) {
      try {
        this.cargandoQuincenas = true;
        const res = await api.get(`organizaciones/calendarios/${organizacionId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        this.quincenas = data
          .filter(q => q.isActive !== false)
          .filter(q => {
            if (!q.fechaLimite) return false;
            const limite = new Date(q.fechaLimite);
            limite.setHours(0, 0, 0, 0);
            return limite >= hoy;
          })
          .sort((a, b) => a.anio - b.anio || a.mes - b.mes || a.quincena - b.quincena);
      } catch (err) {
        console.error('Error al cargar el calendario de la organización:', err);
        this.quincenas = [];
      } finally {
        this.cargandoQuincenas = false;
      }
    },

    onChangeQuincena() {
      const quincena = this.quincenas.find(q => q.id === this.filtros.quincenaId);
      if (!quincena) {
        this.filtros.fechaInicial = '';
        this.filtros.fechaFinal = '';
        return;
      }
      this.filtros.fechaInicial = this.toDateInputValue(quincena.fechaInicio);
      this.filtros.fechaFinal = this.toDateInputValue(quincena.fechaFin);
    },

    toDateInputValue(val) {
      if (!val) return '';
      return String(val).slice(0, 10);
    },

    quincenaLabel(q) {
      const mes = MESES[q.mes - 1] || `Mes ${q.mes}`;
      return `${mes} ${q.anio} - Qna. ${q.quincena}`;
    },

    // TODO: sustituir por la llamada real al endpoint de búsqueda cuando esté disponible.
    // Por ahora se muestra, a manera de ejemplo, el contenido de "Ejemplo pagos SIMM.xlsx".
    async buscar() {
      this.buscando = true;
      this.buscado = false;
      try {
        await new Promise(resolve => setTimeout(resolve, 300));
        this.rows = EJEMPLO_PAGOS.map(row => ({ ...row, _incluir: false }));
      } finally {
        this.buscando = false;
        this.buscado = true;
      }
      await this.$nextTick();
      this.actualizarAlturaTabla();
    },

    toggleTodos(e) {
      const val = e.target.checked;
      this.rows.forEach(row => (row._incluir = val));
    },

    // Si no se marcó ningún check de "Incluir", se exportan todos los
    // registros de ejemplo que aparecen en la tabla "Resultados".
    getSeleccionados() {
      if (!this.rows.length) return null;
      const seleccionados = this.rows.filter(row => row._incluir);
      return seleccionados.length ? seleccionados : this.rows;
    },

    fechaArchivo() {
      return new Date().toISOString().slice(0, 10);
    },

    columnasExportables() {
      return this.columns.filter(c => c.value !== '_incluir');
    },

    descargarBlob(blob, filename) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    // Reproduce el layout original (DEPENDENCIA/QNA/POLIZA/RFC/EMPLEADO/IMPORTE),
    // tal como llega el archivo que sube cada organización.
    exportarFormatoOrganizacion() {
      const seleccionados = this.getSeleccionados();
      if (!seleccionados) return;

      const data = seleccionados.map(({ _incluir, ...rest }) => rest);
      const sheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, sheet, 'Registros');
      XLSX.writeFile(workbook, `instalacion_${this.fechaArchivo()}.xlsx`);
    },

    exportarXLS() {
      const seleccionados = this.getSeleccionados();
      if (!seleccionados) return;

      const data = seleccionados.map(({ _incluir, ...rest }) => rest);
      const sheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, sheet, 'Registros');
      XLSX.writeFile(workbook, `instalacion_${this.fechaArchivo()}.xls`, { bookType: 'xls' });
    },

    exportarTXT() {
      const seleccionados = this.getSeleccionados();
      if (!seleccionados) return;

      const cols = this.columnasExportables();
      const lineas = [cols.map(c => c.text).join('\t')];
      seleccionados.forEach(row => {
        lineas.push(cols.map(c => row[c.value] ?? '').join('\t'));
      });

      const blob = new Blob([lineas.join('\n')], { type: 'text/plain;charset=utf-8;' });
      this.descargarBlob(blob, `instalacion_${this.fechaArchivo()}.txt`);
    },

    async exportarPDF() {
      const seleccionados = this.getSeleccionados();
      if (!seleccionados) return;

      const cols = this.columnasExportables();
      const container = document.createElement('div');
      container.style.padding = '16px';

      const tabla = document.createElement('table');
      tabla.style.width = '100%';
      tabla.style.borderCollapse = 'collapse';
      tabla.style.fontSize = '11px';

      const thead = document.createElement('thead');
      const headRow = document.createElement('tr');
      cols.forEach(c => {
        const th = document.createElement('th');
        th.textContent = c.text;
        th.style.border = '1px solid #ccc';
        th.style.padding = '4px';
        th.style.background = '#f1f1f1';
        headRow.appendChild(th);
      });
      thead.appendChild(headRow);
      tabla.appendChild(thead);

      const tbody = document.createElement('tbody');
      seleccionados.forEach(row => {
        const tr = document.createElement('tr');
        cols.forEach(c => {
          const td = document.createElement('td');
          td.textContent = c.value === 'IMPORTE' ? this.formatCurrency(row[c.value]) : (row[c.value] ?? '');
          td.style.border = '1px solid #ccc';
          td.style.padding = '4px';
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      tabla.appendChild(tbody);
      container.appendChild(tabla);

      try {
        await html2pdf().set({
          margin: 8,
          filename: `instalacion_${this.fechaArchivo()}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'mm', format: 'letter', orientation: 'landscape' },
        }).from(container).save();
      } catch (err) {
        console.error('Error al generar el PDF:', err);
        alert('Hubo un error al generar el PDF.');
      }
    },

    formatCurrency(value) {
      if (value == null || value === '') return '—';
      const num = Number(value);
      if (Number.isNaN(num)) return String(value);
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
    },
  },
};
</script>

<style scoped>
/*
 * DataTable renders its own ".table-responsive" wrapper, which sets
 * overflow-x: auto — per the CSS overflow spec that forces overflow-y to
 * compute as auto too, turning it into its own scroll container. If the
 * max-height/overflow-y lived on this outer ".tabla-scroll" div instead,
 * "thead"'s sticky positioning would resolve against ".table-responsive"
 * (unconstrained height) rather than this element, and never stick.
 * So the scroll container has to be ".table-responsive" itself.
 */
.tabla-scroll :deep(.table-responsive) {
  max-height: var(--tabla-max-height, 500px);
  overflow-y: auto;
}
.tabla-scroll :deep(thead) {
  position: sticky;
  top: 0;
  z-index: 1;
}
.tabla-scroll :deep(thead th) {
  background-color: #fff;
}
</style>
